import React, { Component, Suspense } from "react";
import {
  withRouter,
  Route,
  Switch,
  HashRouter as Router,
  Redirect,
} from "react-router-dom";
import { IRoutePath } from "./models/utilitiesModel";
import routes from "./routes";
import "./custom.css";
import "./App.scss";
import AppIdle from "./AppIdle";
import { initVersionCheck } from "./helpers/helpersIndex";

// HOC for Suspense fallback loading
function withLayout(WrappedComponent) {
  return class extends React.Component {
    render() {
      return (
        <Suspense
          fallback={
            <div className="appLoading">
              Loading{" "}
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          }
        >
          <WrappedComponent {...this.props} />
        </Suspense>
      );
    }
  };
}

let previousPath;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInitialScreen: true,
    };
  }

  componentDidMount() {
    // Version check in production
    if (process.env.NODE_ENV === "production") {
      initVersionCheck("version.json");
    }

    // Prevent default browser back
    window.history.pushState(null, "", window.location.href);
    previousPath = window.location.hash;

    window.onpopstate = function () {
      if (previousPath !== window.location.hash) {
        let index = routes
          .filter((y) => y.ispublic || (y.isClient && !y.isProfilePath))
          .findIndex(
            (x) =>
              "#" + x.path === previousPath ||
              "#" + x.path === window.location.hash
          );
        previousPath = window.location.hash;
        if (index !== -1)
          window.history.pushState(null, "", window.location.href);
      } else {
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Show splash screen for 5 seconds
    setTimeout(() => {
      this.setState({ showInitialScreen: false });
    }, 5000);
  }

  render() {
    const { showInitialScreen } = this.state;

    const PrivateRoute = ({ component: Component, ...rest }) => {
      let isAuthenticated = "1"; // Replace with real logic if needed
      return (
        <Route
          {...rest}
          render={(props) =>
            isAuthenticated === IRoutePath.isAuthenticated ? (
              <Component {...props} />
            ) : (
              <Redirect to={isAuthenticated} />
            )
          }
        />
      );
    };

    // if (showInitialScreen) {
    //   return (
    //     <div className="initial-screen">
    //       <h2>Dive with Name is Empty</h2>
    //     </div>
    //   );
    // }

    return (
      <React.Fragment>
        <AppIdle />
        <Router>
          <Switch>
            {routes.map((route, idx) =>
              route.ispublic ? (
                <Route
                  path={route.path}
                  exact
                  component={route.component}
                  key={idx}
                />
              ) : (
                <PrivateRoute
                  path={route.path}
                  exact
                  component={withLayout(route.component)}
                  key={idx}
                />
              )
            )}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
